// Update ticket names API
const baseUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || "";


export const updateTicketNamesApi = async (ticketId: string, data: any): Promise<any> => {
    try {
        const response = await fetch(`${baseUrl}/user/payment/update-ticket?ticketId=${ticketId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            // Parse error response body for specific error messages
            try {
                const errorData = await response.json();
                return {
                    success: false,
                    error: errorData.message || `HTTP error! status: ${response.status}`,
                    statusCode: response.status
                };
            } catch (parseError) {
                return {
                    success: false,
                    error: `HTTP error! status: ${response.status}`,
                    statusCode: response.status
                };
            }
        }

        const responseData = await response.json();
        return {
            success: true,
            data: responseData,
            message: responseData.message
        };
    } catch (error: any) {
        console.error('Update ticket names error:', error);
        return {
            success: false,
            error: error.message || 'Network error'
        };
    }
};